import {Pipe, PipeTransform} from '@angular/core';
import {snakeCase} from 'lodash';

@Pipe({name: 'snake'})
export class SnakePipe implements PipeTransform {
  transform(value: string, args: string[]): any {
    return snakeCase(value);
  }
}
